import { authStore } from "../auth/authStore";
import { logout } from "../auth/logout";

const BASE_URL = 'https://dev.hbl-pa.vassardigital.ai/api';

const SESSION_EXPIRED = "Session expired. Please log in again.";

const USERMGMT_API = "https://dev.hbl-pa.vassardigital.ai/um";

//LOCAL
// const BASE_URL = 'https://dedra-microclimatological-luis.ngrok-free.dev/api';

export async function apiFetch(
  endpoint: string,
  options: RequestInit = {},
  responseType: "json" | "blob" = "json",
  isUmUrl: boolean = false,
  resourceName?: string
) {
  const token = await authStore.getFreshToken();
  if (!token) {
    logout();
    throw new Error(SESSION_EXPIRED);
  }
  const csrfToken = localStorage.getItem("csrfToken") || "";
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "");
  const userPermissions = JSON.parse(localStorage.getItem("userPermissions") || "");

  const defaultHeaders = {
    "Content-Type": "application/json",
    keycloakauthorization: `Bearer ${token}`,
    "csrf-token": `${csrfToken}`,
    'ngrok-skip-browser-warning': 'true',
    userId: userInfo?.userId ?? '',
    applicationId : userPermissions?.['HBL Performance Analysis']?.applicationId,
    ...(resourceName ? { resourceId : userPermissions?.['HBL Performance Analysis']?.resources?.[resourceName]?.resourceId } : {})
  };


  const url = isUmUrl
    ? `${USERMGMT_API}${endpoint}`
    : `${BASE_URL}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
  });

  // Token rejected by the backend even after refresh: session is gone, send user to login
  if (response.status === 401) {
    logout();
    throw new Error(SESSION_EXPIRED);
  }

  // Handle error
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || "API Error");
  }

  if (responseType === "blob") {
    const blob = await response.blob();

    return {
      data: blob,
      headers: response.headers
    };
  }

  return response.json();
}
